// Adapted from https://github.com/codegenixdev/react-hook-form-mui-zod-boilerplate
// and YT video https://www.youtube.com/watch?v=JyeWoqWsQFo
import { Autocomplete, AutocompleteProps, SxProps, TextField, Theme } from '@mui/material'
import errorShake from '@utils/animations'
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form'

type Props<T extends FieldValues> = Omit<AutocompleteProps<any, any, any, any>, 'renderInput'> & {
	name: Path<T>
	required?: boolean
	options?: any[]
	label: string
	fullWidth?: boolean
	sx?: SxProps<Theme>
}

export default function RHFAutocompleteBase<T extends FieldValues>({
	name,
	options = null,
	label,
	fullWidth = false,
	required = false,
	sx = null,
	...rest
}: Props<T>) {
	const { control } = useFormContext()

	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { onChange, ref, value }, fieldState: { error } }) => (
				<Autocomplete
					sx={sx}
					value={value || null}
					autoComplete={false}
					fullWidth={fullWidth}
					options={options || []}
					autoHighlight
					onChange={(_, newValue) => {
						onChange(newValue)
					}}
					renderInput={(params) => (
						<TextField
							sx={{
								'@keyframes shake': errorShake,
								animation: error ? 'shake 0.25s' : null,
							}}
							{...params}
							autoComplete="noAutocomplete"
							fullWidth
							inputRef={ref}
							error={!!error}
							helperText={error?.message}
							label={required ? `${label} *` : label}
						/>
					)}
					{...rest}
				/>
			)}
		/>
	)
}
